import axios from "axios";

const BASE_URL = process.env.REACT_APP_MAIRA_AI_ASSISTANT_URL;

/** Sends a user message to the assistant and returns the parsed response body. */
export async function askAssistant({ clientKey, message, userId, memberId, sessionId, widgetLanguage }) {
  const response = await axios.post(`${BASE_URL}api/ask`, {
    clientKey,
    message,
    user_id: userId,
    member_id: memberId,
    session_id: sessionId,
    language: widgetLanguage
  });
  return response.data;
}

/** Fetches a page of past conversations for the given session. */
export async function fetchConversationsApi({ clientKey, sessionId, start, size }) {
  const response = await axios.post(`${BASE_URL}api/conversations`, {
    clientKey,
    session_id: sessionId,
    start,
    size,
  });
  return response.data;
}

export async function validateSessionStatus({ clientKey, sessionId }) {
  const response = await axios.post(`${BASE_URL}api/validate-session-status`, {
    clientKey,
    session_id: sessionId,
  });
  return response.data;
}

export async function deleteSession({ clientKey, sessionId }) {
  const response = await axios.delete(`${BASE_URL}api/delete-session`, {
    data: {
      clientKey: clientKey,
      session_id: sessionId,
    }
  });
  return response.data;
}
export async function getSessionList({ clientKey, userId, start }) {
  const response = await axios.post(`${BASE_URL}api/sessions`, {
    clientKey,
    userId: userId,
    start: start,
    size: 10
  });
  return response.data;
}
export async function saveFeedback({ clientKey, conversation_id, feedback_type, message }) {
  let requestData = {
    clientKey,
    conversation_id: conversation_id,
    type: feedback_type,
  };
  requestData["message"] = message;

  await axios.put(
    process.env.REACT_APP_MAIRA_AI_ASSISTANT_URL + 'api/conversations/feedback',
    requestData
  );

}